import { useApi } from '@/api';
import { ChartSkeleton, KpiCard, KpiSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex } from '@blockanalitica/ui';
import HistoricTabs from './HistoricTabs';

export default function OverviewKpis({ daysAgo }) {
  const [data, error] = useApi({
    url: '/groups/core/',
    queryParams: {
      days_ago: daysAgo
    }
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <Flex flexDirection="column" gap="m">
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <KpiCard
            title="Total Debt"
            variant="dai"
            data={data}
            field="debt"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: tokensMapping('DAI'),
                  iconSize: '4'
                }
              }
            }}
          />

          <KpiCard
            title="Total Collateral"
            data={data}
            field="collateral"
            options={{
              valueOptions: {
                currencyValueOptions: {
                  currency: 'USD'
                }
              }
            }}
          />
        </Flex>

        <HistoricTabs />
      </Flex>
    );
  }

  return (
    <>
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <KpiSkeleton />
        <KpiSkeleton />
      </Flex>
      <ChartSkeleton />
    </>
  );
}
